import { Container, Header } from 'features/shared/ui/Page';
import React, { useEffect } from 'react';

import { useSurveysContext } from './SurveysContext';
import MonitoringTSOR from './MonitoringTSOR';

const Component = () => {
  const { avalibleSurvey, showTooltip, setShowTooltip } = useSurveysContext();

  useEffect(() => {
    if (showTooltip) {
      setShowTooltip(false);
    }
  }, [avalibleSurvey]);

  if (avalibleSurvey === 'surveyMonitoringTSOR') return <MonitoringTSOR />;
  return (
    <Container style={{ minHeight: 'calc(100vh - 71px)', height: '100%' }}>
      <Header>На данные момент у нас нет открытых опросов</Header>
    </Container>
  );
};

export default Component;
